import config from '@/config';
import api from '@/shared/api';
import { getTime } from '@/shared/utils/dateHelper';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export const useCreateTaskTimeRegistration = () => {
    const intl = useIntl();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .post(`${config.appUrls.api}/api/registration/CreateTaskTimeRegistration/?now=${getTime()}`, values)
        .then(res => res.data), {
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        createTaskTimeRegistration: mutateAsync,
        isLoading,
        error,
    };
};
